import { createRouter } from 'cell-router';
import { parseURLData } from 'web-utility';

export const { renderMode = 'sync' } = parseURLData() as {
    renderMode?: 'sync';
};

export const { Link, Route } = createRouter();
